'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WebItemInfo = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _baseBcReactComponent = require('@bibliocommons/base-bc-react-component');

var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);

var _baseInlineTextField = require('@bibliocommons/base-inline-text-field');

var _baseInlineTextField2 = _interopRequireDefault(_baseInlineTextField);

require('../styles/WebItemInfo.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var WebItemInfo = exports.WebItemInfo = function (_BcReactComponent) {
  _inherits(WebItemInfo, _BcReactComponent);

  function WebItemInfo() {
    _classCallCheck(this, WebItemInfo);

    return _possibleConstructorReturn(this, (WebItemInfo.__proto__ || Object.getPrototypeOf(WebItemInfo)).apply(this, arguments));
  }

  _createClass(WebItemInfo, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: 'cp-user-list-web-item-info' },
        _react2.default.createElement(
          _baseInlineTextField2.default,
          {
            id: this.props.id,
            labelledById: this.props.labelledById,
            value: this.props.item.getIn(['urlListItem', 'url', 'title']),
            highlightOnHover: true,
            handleChange: this.props.handleChange,
            prompt: this.props.intl.formatMessage({ id: 'user_list_add_web_url' }),
            customClass: 'list-web-url-title-input',
            buttonTestId: 'web-item-title-inline-edit-btn',
            inputTestId: 'web-item-title-inline-edit-text-area' },
          _react2.default.createElement(
            'span',
            { className: 'title', 'data-test-id': 'web-item-title' },
            this.props.item.getIn(['urlListItem', 'url', 'title'])
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'link', 'data-test-id': 'web-item-link' },
          this.props.item.getIn(['urlListItem', 'url', 'url'])
        ),
        _react2.default.createElement(
          'div',
          { className: 'format' },
          WebItemInfo.renderFormat()
        )
      );
    }
  }], [{
    key: 'renderFormat',
    value: function renderFormat() {
      return _react2.default.createElement(
        'span',
        null,
        _react2.default.createElement('i', { 'aria-hidden': true, className: 'icon-export' }),
        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'list_web_resource' })
      );
    }
  }]);

  return WebItemInfo;
}(_baseBcReactComponent2.default);

var propTypes = {
  id: _react.PropTypes.string,
  item: _react.PropTypes.object.isRequired,
  labelledById: _react.PropTypes.string.isRequired,
  handleChange: _react.PropTypes.func,
  intl: _reactIntl.intlShape
};

WebItemInfo.propTypes = propTypes;

exports.default = (0, _reactIntl.injectIntl)(WebItemInfo);


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/user-list/lib/components/web-item-info/components/WebItemInfo.component.js
// module id = 1358
// module chunks = 0